
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class PageHeroContainer extends Vue {
  @Prop({ type: Boolean, default: true })
  readonly showHeroInner!: boolean;

  @Prop(String)
  readonly backgroundImage!: string;

  @Prop(Number)
  readonly aspectRatio!: number;

  @Prop([Number, String])
  readonly maxHeight!: number | string;

  @Prop([Number, String])
  readonly minHeight!: number | string;

  @Prop({ type: String, default: '' })
  readonly containerClass!: string;

  @Prop({ type: String, default: 'bg-overlay full-width' })
  readonly bgOverlayClass!: string;

  @Prop({
    type: String,
    default:
      'img-container full-width fill-height d-flex align-center justify-center',
  })
  readonly imgContainerClass!: string;

  @Prop({
    type: String,
    default: 'pb-16 hero-inner fill-height d-flex flex-column justify-end',
  })
  readonly innerContainerClass!: string;

  @Prop({ type: String, default: 'content-container fill-height py-9' })
  readonly heroContainerClass!: string;

  handleImageLoaded(event: Event) {
    (this.$refs?.imgContainer as HTMLElement)?.classList?.add('bg-fade-in');
    (event.currentTarget as HTMLElement)?.remove();
  }

  get style() {
    const style: Record<string, string | number> = {
      '--background-image-url': this.backgroundImage
        ? `url(${this.backgroundImage})`
        : '',
    };

    if (this.aspectRatio) {
      style['--hero-aspect-ratio'] = this.aspectRatio;
    }

    if (this.maxHeight !== undefined) {
      style['--hero-max-height'] =
        typeof this.maxHeight === 'string'
          ? this.maxHeight
          : `${this.maxHeight}px`;
    }

    if (this.minHeight !== undefined) {
      style['--hero-min-height'] =
        typeof this.minHeight === 'string'
          ? this.minHeight
          : `${this.minHeight}px`;
    }
    return style;
  }
}
